export default __webpack_public_path__ + "static/media/certificat.b2866363.svg";